







import { Component, Prop, Vue } from 'vue-property-decorator';
import DownloadWx from './components/common/download-wx.vue';
import OutsidePage from './components/outside-wx/outside-page.vue';
import { url } from '@tencent/ppd-base-libs';

@Component({
  components: {
    DownloadWx,
    OutsidePage,
  },
})
export default class CIndex extends Vue {

  get bgColor() {
    let bgColor = url.getUrlParam('bgColor');
    if (!/[0-9a-z]/i.test(bgColor)) {
      bgColor = 'f7f3ef';
      // 8b2792
    }
    return `#${bgColor}`;
  }
}
